import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';
import { getCanoneMarketplace, updateCanoneMarketplace, getOriginiOrdini } from '../services/api';
import { useParams, useNavigate } from 'react-router-dom';
import { useTornaIndietro } from '../common/navigazione';

const EditCanoneMarketplace = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tornaIndietro = useTornaIndietro('/canoni-marketplace');
  const [formData, setFormData] = useState({
    denominazione: '',
    percentuale: 0,
    percentuale_include_iva: true,
    costo_fisso: 0,
    origine: '', // NEW
  });
  const [originiOrdini, setOriginiOrdini] = useState([]); // NEW
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => { // Renamed from fetchCanoneData
      try {
        const [canoneResponse, originiResponse] = await Promise.all([ // Parallel fetch
            getCanoneMarketplace(id),
            getOriginiOrdini(),
        ]);
        setFormData(canoneResponse.data);
        setOriginiOrdini(originiResponse.data);
      } catch (err) {
        setError('Errore nel caricamento dei dati del canone o delle origini.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData(); // Call the combined fetch
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    let newValue = value;

    if (type === 'number') {
      newValue = parseFloat(value);
    }

    setFormData({
      ...formData,
      [name]: newValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.denominazione) {
      alert('La denominazione è obbligatoria.');
      return;
    }

    try {
      await updateCanoneMarketplace(id, formData);
      alert('Canone aggiornato con successo!');
      navigate('/canoni-marketplace');
    } catch (error) {
      console.error("Errore nell'aggiornamento del canone:", error.response || error);
      alert(`Errore nell'aggiornamento del canone: ${error.response?.data?.detail || 'Errore sconosciuto'}`);
    }
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
        <p>Caricamento dati canone...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-5">
        <Alert variant="danger">{error}</Alert>
        <Button variant="secondary" onClick={tornaIndietro}>Torna alla lista</Button>
      </Container>
    );
  }

  return (
    <Container>
        <Row className="align-items-center mb-3">
            <Col>
                <h2>Modifica Canone: {formData.denominazione}</h2>
            </Col>
            <Col xs="auto" className="ms-auto">
                <Button variant="secondary" onClick={() => navigate('/canoni-marketplace')} className="me-2">
                    Indietro
                </Button>
                <Button variant="primary" type="submit" form="canone-edit-form">
                    Salva Modifiche
                </Button>
            </Col>
        </Row>
      <Form id="canone-edit-form" onSubmit={handleSubmit}>
        <Card className="mb-4">
          <Card.Header>Dettagli Canone Marketplace</Card.Header>
          <Card.Body>
            <Row className="mb-3">
              <Form.Group as={Col} md={12} controlId="formDenominazione">
                <Form.Label>Denominazione</Form.Label>
                <Form.Control 
                  type="text" 
                  name="denominazione" 
                  value={formData.denominazione} 
                  onChange={handleChange} 
                  placeholder="Es. IBS, FELTRINELLI" 
                  required 
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md={6} controlId="formPercentuale">
                <Form.Label>Percentuale (%)</Form.Label>
                <Form.Control 
                  type="number" 
                  name="percentuale" 
                  value={formData.percentuale} 
                  onChange={handleChange} 
                  step="0.01"
                  min="0"
                />
              </Form.Group>
              <Form.Group as={Col} md={6} controlId="formCostoFisso">
                <Form.Label>Costo Fisso (€)</Form.Label>
                <Form.Control 
                  type="number" 
                  name="costo_fisso" 
                  value={formData.costo_fisso} 
                  onChange={handleChange} 
                  step="0.01"
                  min="0"
                />
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md={12} controlId="formPercentualeIva" className="mt-2">
                <Form.Check
                  type="switch"
                  label="La percentuale è comprensiva di IVA (l'IVA sulla commissione è detraibile: la commissione netta è percentuale ÷ 1,22 su articolo + spedizione)"
                  checked={formData.percentuale_include_iva !== false}
                  onChange={(e) => setFormData({ ...formData, percentuale_include_iva: e.target.checked })}
                />
              </Form.Group>
            </Row>
            <Row className="mb-3"> {/* NEW ROW FOR ORIGINE */}
              <Form.Group as={Col} md={6} controlId="formOrigine">
                <Form.Label>Origine</Form.Label>
                <Form.Select 
                  name="origine" 
                  value={formData.origine} 
                  onChange={handleChange}
                >
                  <option value="">Seleziona Origine</option>
                  {originiOrdini.map(origine => (
                    <option key={origine} value={origine}>{origine}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>
      </Form>
    </Container>
  );
};

export default EditCanoneMarketplace;
